/**
 * Format number as Indian Rupee currency
 * @param {number} value - The numeric value to format
 * @returns {string} Formatted currency string (e.g., "₹1,23,456")
 */
export function formatINR(value) {
    if (value === null || value === undefined || isNaN(value)) {
        return '₹0';
    }
    
    return new Intl.NumberFormat('en-IN', {
        style: 'currency',
        currency: 'INR',
        maximumFractionDigits: 0
    }).format(value);
}
